import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "@/router";
import "@/i18n";
import "@/index.css";

function App() {
  return (
    <Suspense
      fallback={
        <div className="flex h-screen w-full items-center justify-center bg-ink-950">
          <div className="font-display text-2xl text-spray animate-pulse">
            RUSTRIOT
          </div>
        </div>
      }
    >
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default App;
